/*!-----------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.3.1(bac26893f27c9ed9e67951f467120ce782f58226)
 * Released under the MIT license
 * https://github.com/Microsoft/vscode/blob/master/LICENSE.txt
 *-----------------------------------------------------------*/

define("vs/languages/css/common/cssWorker.nls.zh-tw", {
	"vs/languages/css/common/cssWorker": [
		"@keyframes {0}",
		"@font-face",
		"重新命名為 \'{0}\'",
	],
	"vs/languages/css/common/parser/cssErrors": [
		"必須是數目",
		"必須是條件",
		"必須是 at-rule 或選取器",
		"必須是點",
		"必須是冒號",
		"必須是分號",
		"必須是字詞",
		"必須是運算式",
		"必須是運算子",
		"必須是識別項",
		"必須是百分比",
		"必須是 URI 或字串",
		"必須是 URI",
		"必須是變數名稱",
		"必須是變數值",
		"必須是屬性值",
		"必須是 {",
		"必須是 }",
		"必須是 [",
		"必須是 ]",
		"必須是 (",
		"必須是 )",
		"必須是逗點",
		"頁面指示詞或預期的宣告",
		"未知的 at-rule",
		"未知的關鍵字",
		"必須是選取器",
		"必須是字串常值",
	],
	"vs/languages/css/common/services/intelliSense": [
		"從紅色、綠色以及藍色值建立色彩。",
		"從紅色、綠色、藍色以及 Alpha 值建立色彩。",
		"從色調、飽和以及光度值建立色彩。",
		"從色調、飽和、光度以及 Alpha 值建立色彩。",
	],
	"vs/languages/css/common/services/lint": [
		"\'{0}\'",
		"{0}，\'{1}\'",
		"定義主要畫面格時，一律定義標準規則 \'@keyframes\'。",
		"一律包含所有的廠商特定規則: 遺漏: {0}",
		"也定義標準的屬性 \'{0}\' 的相容性",
		"一律包含所有的廠商特定屬性: 遺漏：{0}",
	],
	"vs/languages/css/common/services/lintRules": [
		"在使用廠商專屬的前置詞時，請確定也包括其他所有的廠商特定屬性。",
		"在使用廠商專屬的前置詞時，也包括標準屬性。",
		"請勿使用重複的樣式定義",
		"請勿使用空白規則集",
		"Import 陳述式不會平行載入",
		"使用填補或框線時不要使用寬度或高度。",
		"已知通用選取器 (*) 速度緩慢",
		"零不需要任何單位",
		"@font-face 規則必須定義 \'src\' 和 \'font-family\' 屬性",
		"十六進位色彩必須由三個或六個十六進位數字組成",
		"無效的參數數目",
		"未知的屬性。",
		"只有在支援 IE7 及更舊的版本時才需要 IE Hack",
		"未知的廠商專屬屬性。",
		"屬性因顯示而忽略。例如，若為 \'display: inline\'，則 width、height、margin-top、margin-bottom 以及 float 屬性就不會有任何作用。",
		"避免使用 !important。這表示整個 CSS 的明確性皆失控，需要重構。",
		"避免使用 \'float\'。浮動會使 CSS 脆弱，在版面配置的任一層面改變時容易中斷。",
		"選取器不應包含 ID，因為這些規則與 HTML 結合過於緊密。",
		"啟用或停用所有驗證",
	]
});